"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_ATTRIBUTES = exports.DATA_HOOKS = exports.ICON_SIZE = void 0;
exports.ICON_SIZE = 24;
exports.DATA_HOOKS = {
    label: 'dropdown-label',
    coreDropdown: 'core-dropdown',
    base: 'dropdown-base',
    nativeSelect: 'native-select',
    baseText: 'dropdown-base-text',
    placeholderOption: 'placeholder-option',
    errorTooltip: 'dropdown-error-tooltip',
};
exports.DATA_ATTRIBUTES = {
    error: 'data-error',
};
//# sourceMappingURL=constants.js.map